import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { addAllList } from 'modules/common';
import { mediaSizeCode } from 'lib/api/code';

import FilterCollection from 'components/organisms/FilterCollection';

const NewSizeTypeFilter = ({ getParam = (f) => f, params }) => {
  const { t } = useTranslation();
  const [sizeTypeList, setSizeTypeList] = useState([]);

  useEffect(() => {
    mediaSizeCode()
      .then((response) => {
        const tempList = addAllList(
          response.data.data,
          'CODE_DESC',
          'CODE_ID',
          'all'
        );
        setSizeTypeList(tempList);
      })
      .catch((error) => {
        alert(error);
      });
  }, []);

  return (
    <>
      <FilterCollection
        label={t('사이즈 형태')}
        name="sizeType"
        params={params}
        value={params.sizeType}
        type="select"
        list={sizeTypeList}
        callBack={getParam}
        labelKey="CODE_DESC"
        valueKey="CODE_ID"
      />
    </>
  );
};

export default NewSizeTypeFilter;
